// extracted by mini-css-extract-plugin
module.exports = {"partDialog":"PartDialog_partDialog__-2oQv","buttons":"PartDialog_buttons__1GSRa","MuiInputBase-input":"PartDialog_MuiInputBase-input__26_vD"};